import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from "react-router-dom";
import moment from 'moment';
import {List} from "immutable";
import _ from "lodash";
import {isInt, isFloat} from 'validator';

// Components
import DateInput from "../../components/common/date-input";
import SerieSelector from "../../components/common/SerieSelector";

// Actions
import { createEmployee, cleanEmployees } from "../../actions/employees";
import {getSeries, cleanSeries} from "../../actions/series";

class NewEmployee extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // series
            serieSelectedId: 'manual',
            serieSelectedValue: '',
            // object fields
            employee_code: '',
            fiscal_id: '',
            laboral_id: '',
            name: '',
            last_name: '',
            date_of_birth: moment(),
            contract_type: '',
            category: '',
            cost_per_hour: '',
            address: '',
            country: '',
            province: '',
            city: '',
            postal_code: '',
            email: '',
            phone: '',
            mobile_phone: '',
            bank_info_name: '',
            bank_info_iban: '',
            bank_info_swift: '',
            canSubmit: false,
        };
    }

    componentDidMount() {
        this.props.getSeries({ document_type: 'employee' });
    }

    componentDidUpdate(prevProps, prevState) {
        // Selected Serie
        if (this.props.series.size > 0 && this.props.series !== prevProps.series) {
            let serieSelectedId = 'manual', serieSelectedValue = '';

            this.props.series.forEach(serie => {
                if (serie.get('is_default')) {
                    serieSelectedId = serie.get('_id');
                    serieSelectedValue = serie.get('prefix') + _.padStart((serie.get('last_count') + 1), serie.get('number_length'), '0')
                }
            });
            this.setState({ serieSelectedId, serieSelectedValue })
        }
    }

    componentWillUnmount() {
        this.props.cleanEmployees();
        this.props.cleanSeries();
    }

    onChangeSerieSelected = (serieSelectedId, serieSelectedValue) => {
        this.setState({
            serieSelectedId,
            serieSelectedValue,
            employee_code: ''
        }, this.validateEmployee);
    };

    onChangeInput = (inputName, inputValue) => {
        this.setState({
            [inputName]: inputValue
        }, this.validateEmployee);
    };

    validateEmployee = () => {
        if (
            (this.state.serieSelectedId !== 'manual' || this.state.employee_code !== '') &&
            this.state.name !== '' &&
            this.state.cost_per_hour !== ''
        ) {
            this.setState({ canSubmit: true });
        }
        else {
            this.setState({ canSubmit: false });
        }
    };

    handleCreateClick = () => {
        this.props.createEmployee({
            serieSelectedId: this.state.serieSelectedId,
            employee_code: this.state.employee_code,
            fiscal_id: this.state.fiscal_id,
            laboral_id: this.state.laboral_id,
            name: this.state.name,
            last_name: this.state.last_name,
            date_of_birth: this.state.date_of_birth,
            contract_type: this.state.contract_type,
            category: this.state.category,
            cost_per_hour: this.state.cost_per_hour,
            address: this.state.address,
            ...(this.state.country !== '') ? { country: this.state.country } : '',
            ...(this.state.province !== '') ? { province: this.state.province } : '',
            ...(this.state.city !== '') ? { city: this.state.city } : '',
            postal_code: this.state.postal_code,
            email: this.state.email,
            phone: this.state.phone,
            mobile_phone: this.state.mobile_phone,
            bank_info_name: this.state.bank_info_name,
            bank_info_iban: this.state.bank_info_iban,
            bank_info_swift: this.state.bank_info_swift
        }, { projection: 'employee_code name last_name email phone mobile_phone fiscal_id status' });
        this.props.history.push('/empleados');
    };

    render() {

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/empleados">Empleados</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Nuevo Empleado</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button
                                className="btn btn-cancel"
                                onClick={ () => this.props.history.push('/empleados') }
                            >Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={ () => this.handleCreateClick() }
                                disabled={!this.state.canSubmit}
                            >Crear
                            </button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Código de empleado *</label>
                                                <div className="row">
                                                    <div className="col" style={{ paddingRight: 0 }} >
                                                        { this.state.serieSelectedId === 'manual'
                                                            ? <input
                                                                className="form-control"
                                                                type="text"
                                                                value={this.state.employee_code}
                                                                onChange={ (event) => {
                                                                    this.setState({
                                                                        employee_code: event.target.value
                                                                    }, this.validateEmployee);
                                                                }}
                                                            />
                                                            : <input
                                                                className="form-control"
                                                                type="text"
                                                                value={ this.state.serieSelectedValue }
                                                                disabled={true}
                                                            />
                                                        }
                                                    </div>
                                                    <div className="col-auto d-flex align-items-center" style={{ paddingLeft: 0 }} >
                                                        { this.props.series.size > 0
                                                            ? <SerieSelector
                                                                series={this.props.series}
                                                                serieSelectedId={this.state.serieSelectedId}
                                                                onChangeSerieSelected={this.onChangeSerieSelected}
                                                            />
                                                            : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>NIF / NIE</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.fiscal_id}
                                                    onChange={ (event) => this.onChangeInput('fiscal_id', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Nº Seguridad Social</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.laboral_id}
                                                    onChange={ (event) => this.onChangeInput('laboral_id', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label>Nombre *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.name}
                                                    onChange={ (event) => this.onChangeInput('name', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label>Apellidos</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.last_name}
                                                    onChange={ (event) => this.onChangeInput('last_name', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Fecha de nacimiento</label>
                                                <DateInput
                                                    onChange={(selectedValue) => this.setState({
                                                        date_of_birth: selectedValue
                                                    })}
                                                    value={this.state.date_of_birth}
                                                    inputWrapperStyle={{height: 40}}
                                                    inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                                    iconStyle={{top: 9, right: 12}}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Tipo de contrato</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.contract_type}
                                                    onChange={ (event) => this.onChangeInput('contract_type', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Categoría</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.category}
                                                    onChange={ (event) => this.onChangeInput('category', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Coste por hora(€) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.cost_per_hour}
                                                    onChange={ (event) => {
                                                        let cost_per_hour = event.target.value;
                                                        if (cost_per_hour === '') cost_per_hour = '0';
                                                        if (isFloat(cost_per_hour)) {
                                                            this.onChangeInput('cost_per_hour', cost_per_hour);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <h4>Domicilio</h4>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label>Dirección</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.address}
                                                    onChange={ (event) => this.onChangeInput('address', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>País</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.country}
                                                    onChange={ (event) => this.onChangeInput('country', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Provincia</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.province}
                                                    onChange={ (event) => this.onChangeInput('province', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Población</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.city}
                                                    onChange={ (event) => this.onChangeInput('city', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Código Postal</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.postal_code}
                                                    onChange={ (event) => {
                                                        const postal_code = event.target.value;
                                                        if (isInt(postal_code) || postal_code === '') {
                                                            this.onChangeInput('postal_code', postal_code);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <h4>Contacto</h4>
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Email</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.email}
                                                    onChange={ (event) => this.onChangeInput('email', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Teléfono</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.phone}
                                                    onChange={ (event) => this.onChangeInput('phone', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Móvil</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.mobile_phone}
                                                    onChange={ (event) => this.onChangeInput('mobile_phone', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <h4>Datos Bancarios</h4>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label>Banco</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.bank_info_name}
                                                    onChange={ (event) => this.onChangeInput('bank_info_name', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>IBAN</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.bank_info_iban}
                                                    onChange={ (event) => this.onChangeInput('bank_info_iban', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Swift</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.bank_info_swift}
                                                    onChange={ (event) => this.onChangeInput('bank_info_swift', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const seriesReducer = state.series;

    // Series
    let series = seriesReducer.get('payload') || List([]);

    return {
        series
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createEmployee: (employee, options) => dispatch(createEmployee(employee, options)),
        cleanEmployees: () => dispatch(cleanEmployees()),
        getSeries: (query) => dispatch(getSeries(query)),
        cleanSeries: () => dispatch(cleanSeries())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewEmployee);



// WEBPACK FOOTER //
// ./src/containers/employees/NewEmployee.js